import { render, staticRenderFns } from "./FiltrosDashboardTab.vue?vue&type=template&id=3b983810&scoped=true"
import script from "./FiltrosDashboardTab.vue?vue&type=script&lang=js"
export * from "./FiltrosDashboardTab.vue?vue&type=script&lang=js"
import style0 from "./FiltrosDashboardTab.vue?vue&type=style&index=0&id=3b983810&prod&scoped=true&lang=css"
import style1 from "./FiltrosDashboardTab.vue?vue&type=style&index=1&id=3b983810&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b983810",
  null
  
)

export default component.exports